module.exports = __webpack_public_path__ + "img/img_024@2x.0333a992.png";